module.exports = __webpack_public_path__ + "static/media/event-volunteers.68d10384.png";